module.exports = __webpack_public_path__ + "img/9600.f7d4647e.jpg";